import type { FieldPath, FieldValues } from "react-hook-form";
import { CdcSelectField, type CdcSelectFieldProps } from "./cdc-field-helpers";
import usStates from "@/data/us-states.json" with { type: "json" };
import countryStates from "@/data/countries-states.json" with { type: "json" };

export type CdcAddressStateFieldProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = Omit<CdcSelectFieldProps<TFieldValues, TName>, "fieldKey" | "options">;

export function CdcAddressStateField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  locale,
  ...rest
}: Readonly<CdcAddressStateFieldProps<TFieldValues, TName>>) {
  const countryCode = locale.slice(3, 5);
  const STATE_OPTIONS =
    countryStates[countryCode as keyof typeof countryStates] || usStates;

  return (
    <CdcSelectField
      {...rest}
      fieldKey="state"
      locale={locale}
      options={STATE_OPTIONS}
    />
  );
}
